import { Box } from './Box';
export const Thing = () => <Box tx={{ color: 'pigeon400' }}>Thingy</Box>;
